module.exports = __webpack_public_path__ + "img/open_access_conference.ab8fdb9a.jpg";